__turbopack_context__.v({
  "conciergeText": "DestinationsPanel-module__thyBqa__conciergeText",
  "content": "DestinationsPanel-module__thyBqa__content",
  "destinationsPanel": "DestinationsPanel-module__thyBqa__destinationsPanel",
  "error": "DestinationsPanel-module__thyBqa__error",
  "errorsContainer": "DestinationsPanel-module__thyBqa__errorsContainer",
  "footer": "DestinationsPanel-module__thyBqa__footer",
  "placeCounter": "DestinationsPanel-module__thyBqa__placeCounter",
  "privacyError": "DestinationsPanel-module__thyBqa__privacyError",
  "requiredStar": "DestinationsPanel-module__thyBqa__requiredStar",
  "section": "DestinationsPanel-module__thyBqa__section",
  "title": "DestinationsPanel-module__thyBqa__title",
  "unreachablePlaces": "DestinationsPanel-module__thyBqa__unreachablePlaces",
});
